// Shared limit for free-text fields that are stored in an encrypted column.
// After widening every such column to varchar(2000) (see the matching Laravel
// migration), any value up to 255 real characters - including worst-case
// 4-byte UTF-8 characters - fits safely once encrypted. This constant is the
// single source of truth for that 255-character rule; do not hardcode 255
// separately in each form.
export const MAX_FIELD_LENGTH = 255;

export function isFieldTooLong(value) {
	// Count Unicode codepoints, not UTF-16 code units - value.length would
	// count each astral character (e.g. emoji) as 2, over-blocking content
	// the widened column can actually hold safely.
	return !!value && Array.from(value).length > MAX_FIELD_LENGTH;
}
